import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StarRatingComponent } from './star-rating.component';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [StarRatingComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [StarRatingComponent]
})
export class StarRatingModule { }
